import {inject, Injectable} from '@angular/core';
import Keycloak from 'keycloak-js';
import {Permission} from "../../interfaces/permission";

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private keycloak: Keycloak;

    constructor() {
        this.keycloak = inject(Keycloak);
    }

    can(permission: Permission): boolean {
        let isAuthorized: boolean = false;
        if (this.keycloak.tokenParsed) {
            let scopes: string[] = this.keycloak.tokenParsed!['scope'].split(' ');
            if (scopes.includes(permission)) {
                isAuthorized = true;
            }
        }
        return isAuthorized;
    }

    canOneOf(permissions: Permission[]): boolean {
        //return true if no permission given, e.g. from menu data
        if (!permissions || permissions.length == 0) {
            return true;
        }

        let isAuthorized: boolean = false;

        permissions.forEach((permission: Permission) => {
            if (this.can(permission)) {
                isAuthorized = true;
            }
        });

        return isAuthorized;
    }

    getUserId(): string {
        return this.keycloak.profile?.id ?? '';
    }
}
